// The API resolves entitlement and availability; never infer a live deal from
// legacy ACTIVE alone or from a frozen presentation snapshot.
export function offerSeoPolicy(offer, { preview = false } = {}) {
  const historical = offer?.computedStatus === 'EXPIRED';
  const publicPage = Boolean(offer && !preview && offer.visibility === 'PUBLIC' && offer.publicationStatus === 'PUBLISHED' && !['CANCELLED','ARCHIVED','PAUSED','DRAFT','REJECTED','SUBMITTED','NEEDS_CHANGES','SCHEDULED'].includes(offer.status));
  const indexable = publicPage && offer.indexable !== false && offer.computedStatus === 'ACTIVE';
  return { historical, indexable, activeDeal: indexable && offer.currentlyRedeemable === true };
}
